import { EndpointsName, get } from "../../Auth";
import { ProcessType } from "../../types";

export const isRunning = (process: ProcessType, optionalParams?: { [x: string]: string }) => {

    const params = optionalParams && Object.keys(optionalParams).length
        ? `?${Object.entries(optionalParams).map(([key, value]) => `${key}=${value}`).join('&')}`
        : '';
        
    return get<boolean>(EndpointsName.BBF, `/${process}/is-process-running${params}`);
};